exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fictitiousCourse .tit[data-v-4cd3bfc8] {\n  width: 100%;\n  height: 0.609375rem;\n  line-height: 0.609375rem;\n  text-align: center;\n  font-size: 0.15625rem;\n  font-family: \"\\9ED1\\4F53\";\n  color: #222;\n}\n.fictitiousCourse .courseL .list[data-v-4cd3bfc8] {\n  width: 100%;\n  margin: 0.104167rem auto 0;\n  display: flex;\n  flex-wrap: wrap;\n}\n.fictitiousCourse .courseL .list .listItem[data-v-4cd3bfc8] {\n  margin: 0 0.078125rem 0.208333rem 0.026042rem;\n}\n.fictitiousCourse .courseL .list .listItem[data-v-4cd3bfc8]:nth-child(6n) {\n  margin-right: 0;\n}\n.paginationX[data-v-4cd3bfc8] {\n  text-align: center;\n}", ""]);

// exports
